<script setup lang="ts">
import { useI18n } from "vue-i18n";

import type { ProfilPreviewAlertProps } from "@/components/modal/Profile/previewProfile/types";

// biome-ignore lint/correctness/noUnusedVariables: Init Biome
const props = defineProps<ProfilPreviewAlertProps>();

const { t } = useI18n();
</script>

<template>
    <div class="profil-preview-alert">
        <i class="profil-preview-alert__icon ti ti-folder-open" />
        <span class="profil-preview-alert__message typo-xxs-regular">
            {{ t("modals.profilPreview.alert.recruitmentCount", recruitmentCount) }}
        </span>
    </div>
</template>

<style scoped lang="scss">
.profil-preview-alert {
    display: flex;
    align-items: center;
    gap: var(--spacing-lg, 12px);
    padding: var(--spacing-md, 8px) var(--spacing-lg, 12px);
    border-radius: var(--radius-xs, 4px);
    border: 1px solid var(--blue-lighter, #ebefff);
    background-color: var(--blue-lightest, #f5f7ff);
    align-self: stretch;

    &__icon {
        color: var(--blue-base, #2051f8);
    }
}
</style>
